<div class="bottomSheetContainer" >
  <div class="button" (click)="dimiss()">
    <div class="btn-ln">
      <div class="line">

      </div>
    </div>
  </div>
  <div class="container">

    <div class="gift-wrapper">
      <span class="title-gift">Tu amigo <!--{{apiResponse.data.original.nombre}}--> quiere compartir esta jugada contigo</span>

      <div class="separator"></div>

      @if (isLogged) {
        <form [formGroup]="loggedForm" (ngSubmit)="logged_acceptSharedPlay()" class="logged-form">
          <mat-checkbox matInput class="checkbox-aceptar"
            [errorStateMatcher]="matcher"
            [(ngModel)]="checked"
            id="aceptarLogged" name="aceptarLogged"
            type="checkbox"
            [color]="primary"
            formControlName="aceptarLogged">
            Acepto el compartir la jugada
          </mat-checkbox>
          <button mat-button class="regalar-button" [disabled]="(!checked && !isLogin) || isLogin" type="submit" >Aceptar y acceder</button>
        </form>
      } @else {
        <mat-tab-group dynamicHeight>
          <mat-tab label="Ya tengo cuenta">
            <form [formGroup]="loginForm" (ngSubmit)="loginAcceptSharedPlay(loginForm)" class="form-gift">
              <mat-form-field class="email-gift-input" appearance="outline">
                <mat-label>Email</mat-label>
                <input id="emailLogin" name="emailLogin" formControlName="emailLogin" type="email" matInput [errorStateMatcher]="matcher"
                  placeholder="Ex. pat@example.com">
                @if (emailLogin.invalid && (emailLogin.dirty || emailLogin.touched)) {
                  <mat-error>
                    ¡Introduce un email valido!
                  </mat-error>
                }
                @if (emailLogin.errors?.required) {
                  <mat-error>
                    Es necesario introducir un email
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="password-gift-input" appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" id="passwordLogin" name="passwordLogin" formControlName="passwordLogin" [errorStateMatcher]="matcher">
                <button matSuffix mat-icon-button type="button" (click)="hidePass()">
                  @if (!hide) {
                    <img src="/assets/images/icons/loginYregistro/eye-off.svg" alt="Ocultar contraseña">
                  }
                  @if (hide) {
                    <img src="/assets/images/icons/loginYregistro/eye-show.svg" alt="Mostrar contraseña">
                  }
                </button>
              </mat-form-field>
              <mat-checkbox matInput class="checkbox-aceptar"
                [errorStateMatcher]="matcher"
                [(ngModel)]="checked"
                id="aceptarLogin" name="aceptarLogin"
                type="checkbox"
                [color]="primary"
                formControlName="aceptarLogin">
                Acepto el compartir la jugada
              </mat-checkbox>
              <button mat-button class="regalar-button" [disabled]="(!checked && !isLogin) || isLogin" type="submit" >Aceptar y acceder</button>
            </form>
          </mat-tab>
          <mat-tab label="Registrarme">
            <form [formGroup]="registerForm" (ngSubmit)="registerAcceptSharedPlay(registerForm)" class="form-gift">
              <mat-form-field class="name-gift-input" appearance="outline">
                <mat-label>Nombre</mat-label>
                <input id="nameRegister" name="nameRegister" formControlName="nameRegister" type="text" matInput [errorStateMatcher]="matcher">
                @if (nameRegister.errors?.required) {
                  <mat-error>
                    Es necesario introducir un nombre
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="email-gift-input" appearance="outline">
                <mat-label>Email</mat-label>
                <input id="emailRegister" name="emailRegister" formControlName="emailRegister" type="email" matInput [errorStateMatcher]="matcher"
                  placeholder="Ex. pat@example.com">
                @if (emailRegister.invalid && (emailRegister.dirty || emailRegister.touched)) {
                  <mat-error>
                    ¡Introduce un email valido!
                  </mat-error>
                }
                @if (emailRegister.errors?.required) {
                  <mat-error>
                    Es necesario introducir un email
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="password-gift-input" appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" id="passwordRegister" name="passwordRegister" formControlName="passwordRegister" [errorStateMatcher]="matcher">
                <button matSuffix mat-icon-button type="button" (click)="hidePass()">
                  @if (!hide) {
                    <img src="/assets/images/icons/loginYregistro/eye-off.svg" alt="Ocultar contraseña">
                  }
                  @if (hide) {
                    <img src="/assets/images/icons/loginYregistro/eye-show.svg" alt="Mostrar contraseña">
                  }
                </button>
                @if (passwordRegisterInvalid) {
                  <mat-error>La contraseña debe ser de al menos 8 caracteres y incluir al menos una
                  mayúscula, minúscula, número y caracter especial.</mat-error>
                }
                @if (first) {
                  <mat-hint>La contraseña debe ser de al menos 8 caracteres y incluir al menos una mayúscula,
                  minúscula, número y caracter especial.</mat-hint>
                }
              </mat-form-field>
              <mat-checkbox matInput class="checkbox-aceptar"
                [errorStateMatcher]="matcher"
                [(ngModel)]="checked"
                id="aceptarRegister" name="aceptarRegister"
                type="checkbox"
                [color]="primary"
                formControlName="aceptarRegister">
                Acepto el compartir la jugada
              </mat-checkbox>
              <button mat-button class="regalar-button" [disabled]="(!checked && !isLogin) || isLogin" type="submit" >Aceptar y acceder</button>
            </form>
          </mat-tab>
        </mat-tab-group>
        <!--
        <div class="buttons">
          <button class="btn-acceder btn-acceder-icon-left" (click)="facebookAcceptSharedPlay()">
            <img src="/assets/images/pages/options-auth/logo-facebook.svg"/>
            <p>Acceder con Facebook</p>
          </button>
          <button class="btn-acceder btn-acceder-icon-left" (click)="googleAcceptSharedPlay()">
            <img src="/assets/images/pages/options-auth/logo-google.svg"/>
            <p> Acceder con Google </p>
          </button>
        </div>
        -->
      }


    </div>

  </div>


</div>